import React from 'react';
import CloudFileManager from './CloudFileManager';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onSelect: (url: string) => void;
}

const FileManagerModal: React.FC<Props> = ({ isOpen, onClose, onSelect }) => {
  if (!isOpen) return null;

  return (
    <div className="modal d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1050 }}>
      <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
        <div className="modal-content" style={{ height: '80vh' }}>
          <div className="modal-body p-0 h-100">
            <CloudFileManager 
              onSelect={(url) => {
                onSelect(url);
                onClose();
              }} 
              onClose={onClose} 
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FileManagerModal;